import React, { Component } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';

export default (Page) => {
  class WrappedComponent extends Component {
    static initialiseI18n({ req }) {
      // eslint-disable-next-line no-underscore-dangle
      const { translations } = req || window.__NEXT_DATA__.props;
      return translations;
    }

    static propTypes = {
      translations: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    };

    constructor(props) {
      super(props);
      i18n.init(this.props.translations);
    }

    render() {
      const passedProps = {
        ...this.props,
      };

      delete passedProps.translations;

      return <Page {...passedProps} />;
    }
  }

  hoistNonReactStatic(WrappedComponent, Page);

  WrappedComponent.displayName = `withI18n(${Page.displayName || Page.name})`;

  return WrappedComponent;
};
